import {MAP} from './common.model';

export interface UserInfo {
    firstName: string;
    lastName: string;
    roles: string[];
}

export class Config {

    config: MAP;
    userInfo: UserInfo;
    vars: any;    // variables used for text substitutions, e.g. {legalName}
    date: Date;
    forSignedUser: boolean;
    guestGroupId: number;
    themes: any[]; // {code:, title:}

    static toJSON(config) {
        const json = config;
        return json;
    }

    static deserialize(json: any): Config {
        let model: Config = null;
        if (json) {
            model = new Config();
            model = Object.assign(model, json);
        }
        return model;
    }

}
